import React, { useRef, useState } from "react";


// Import Swiper React components
function ContactForm() {
  
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        address: '',
        message: '',
        error: '',
        isSubmitting: false,
        isSuccess: false,
        successMessage: '',
      });

      const handleChange = (e) => {
        const { name, value } = e.target;
        
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      };
    
      const handleSubmit = async(e) => {
        e.preventDefault();
        if(formData.name.trim() === ''){
          setFormData((prevData) => ({
            ...prevData,
            error: 'Name is required',
            isSubmitting: false,
          }));
        }
        else if(formData.email.trim() !== '' && !formData.email.includes('@')){
          setFormData((prevData) => ({
            ...prevData,
            error: 'Invalid email',
            isSubmitting: false,
          }));
        }
        else if(formData.phone.trim() === ''){
          setFormData((prevData) => ({
            ...prevData,
            error: 'Phone is required',
            isSubmitting: false,
          }));
        }
        else if(formData.message.trim() === ''){
          setFormData((prevData) => ({
            ...prevData,
            error: 'Message is required',
            isSubmitting: false,
          }));
        }
        else{
          setFormData((prevData) => ({
            ...prevData,
            error: '',
            isSubmitting: true,
            // isSuccess: true,
            // successMessage: 'Thank you for contacting us. We will get back to you soon.',
          }));
          

          // const API_URL = "https://healthfitsquare.com/api/";
          const API_URL = "http://89.116.121.184/api/";
          // const API_URL = "http://localhost:8000/";
          const API_ENDPOINT = "HealthfitMailer";
          
          const requestData = {
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            address: formData.address,
            message: formData.message,
          };

          const response = await fetch(`${API_URL}${API_ENDPOINT}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestData),
          });

          if(response.ok){
            setFormData((prevData) => ({
              ...prevData,
              isSuccess: true,
              successMessage: 'Thank you for contacting us. We will get back to you soon.',
            }));

            setFormData((prevData) => ({
              ...prevData,
              name: '',
              email: '',
              phone: '',
              address: '',
              message: '',
              error: '',
              isSubmitting: false,
            }));
            // setTimeout(() => {
            //   setFormData((prevData) => ({
            //     ...prevData,
            //     name: '',
            //     email: '',
            //     phone: '',
            //     address: '',
            //     message: '',
            //     error: '',
            //     isSubmitting: false,
            //     isSuccess: false,
            //     successMessage: '',
            //   }));
            // }, 3000);
          }
          else{
            setFormData((prevData) => ({
              ...prevData,
              error: 'Something went wrong. Please try again later.',
              isSubmitting: false,
            }));
          }


        // console.log('Form Data Submitted:', formData);
        // alert(`Submitted Data:\n${JSON.stringify(formData, null, 2)}`);
      };
    }

      
  return (
    <div className="App">



                                {/* <!-- Contact Form Start --> */}
                                <div className="contact-form">
                                    {formData.isSuccess && (
                                        <div className="alert alert-success">
                                            {formData.successMessage}
                                        </div>
                                    )}

      <form id="contact-form" onSubmit={handleSubmit}>
        <div className="row gx-3">
          <div className="col-md-6">
            <div className="single-form">
              <input
              required
                name="name"
                type="text"
                placeholder="Name*"
                value={formData.name}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="single-form">
              <input
                name="email"
                type="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="single-form">
              <input
              required
                name="phone"
                type="text"
                placeholder="Phone*"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="single-form">
              <input
                name="address"
                type="text"
                placeholder="Address"
                value={formData.address}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="single-form">
              <textarea
              required
                name="message"
                placeholder="Message*"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>
          </div>
          {formData.error && (
            <div className="col-md-12">
              <div className="single-form">
                <p className="error-message">{formData.error}</p>
              </div>
            </div>
          )}
          <div className="col-md-12">
            <div className="single-form">
              <button type="submit" className="btn btn-secondary btn-hover-primary" disabled={formData.isSubmitting}>
                {formData.isSubmitting ? 'Submitting...' : 'Submit Now'}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
                                {/* <!-- Contact Form End --> */}

                      

    </div>
  )
}

export default ContactForm
